export default __webpack_public_path__ + "static/media/vuePixi.0b334d52.png";